module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-the-weird-in-austin-texas-f32db7bf7eefd10139d308e5ff0a7b56.png";